import { render } from "./BananaCardItemPreview.vue?vue&type=template&id=b548fa34&scoped=true"
import script from "./BananaCardItemPreview.vue?vue&type=script&lang=js"
export * from "./BananaCardItemPreview.vue?vue&type=script&lang=js"

import "./BananaCardItemPreview.vue?vue&type=style&index=0&id=b548fa34&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b548fa34"]])

export default __exports__